// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollmentScenario;
(function (EnrollmentScenario) {
    EnrollmentScenario[EnrollmentScenario["Undetermined"] = 0] = "Undetermined";
    EnrollmentScenario[EnrollmentScenario["NewEnrollment"] = 1] = "NewEnrollment";
    EnrollmentScenario[EnrollmentScenario["Update"] = 2] = "Update";
    EnrollmentScenario[EnrollmentScenario["KeyUpdate"] = 3] = "KeyUpdate";
    EnrollmentScenario[EnrollmentScenario["ReEnrollment"] = 4] = "ReEnrollment";
    EnrollmentScenario[EnrollmentScenario["DisEnrollment"] = 5] = "DisEnrollment";
})(EnrollmentScenario || (EnrollmentScenario = {}));
//# sourceMappingURL=enrollmentScenario.js.map